import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/**
 * Selo "Anonimizado em dd/mm/aaaa" exibido na ficha e na listagem de pacientes
 * quando o paciente foi anonimizado (LGPD). Segue o estilo de pílula do StatusBadge.
 * Com `label="Excluído em"` vira o selo da ficha lápide (paciente excluído).
 */
export function formatAnonymizedDate(anonymizedAt) {
    if (!anonymizedAt) return '';
    const datePart = String(anonymizedAt).split(' ')[0];
    const [year, month, day] = datePart.split('-');
    if (!year || !month || !day) return '';
    return `${day}/${month}/${year}`;
}

function AnonymizedBadge({ anonymizedAt, compact = false, label = 'Anonimizado em' }) {
    if (!anonymizedAt) return null;

    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.6,
                px: compact ? 1 : 1.25,
                py: compact ? 0.25 : 0.4,
                borderRadius: '20px',
                backgroundColor: '#F5F5F5',
                border: '1px solid #E0E0E0',
                width: 'fit-content',
            }}
        >
            <Box
                sx={{
                    width: 6,
                    height: 6,
                    borderRadius: '50%',
                    backgroundColor: '#9E9E9E',
                    flexShrink: 0,
                }}
            />
            <Typography
                variant="caption"
                sx={{
                    fontWeight: 500,
                    fontSize: compact ? '0.6875rem' : '0.75rem',
                    lineHeight: 1,
                    color: '#616161',
                    whiteSpace: 'nowrap',
                }}
            >
                {`${label} ${formatAnonymizedDate(anonymizedAt)}`}
            </Typography>
        </Box>
    );
}

export default AnonymizedBadge;
